<template>
    <div class="invoicing position-relative has-tool-menu stock-mgmt">
        <div class="tool-menu">
            <Breadcrumb />

            <div class="buttons">
                <ButtonAreas :entities="selected" />
            </div>
        </div>

        <b-card no-body header="Terminaler">
            <b-card-body class="p-2">

                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Navn</th>
                            <th>Standard</th>
                            <th>Skjult</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in terminals" :key="item.id">
                            <td class="font-xl">
                                {{item.terminalId}}
                            </td>
                            <td>
                                <b-form-input v-model="item.name"></b-form-input>
                            </td>
                            <td>
                                <b-form-checkbox v-model="item.default" @change="setDefault(item)"></b-form-checkbox>
                            </td>
                            <td>
                                <b-form-checkbox v-model="item.deleted"></b-form-checkbox>
                            </td>
                        </tr>
                    </tbody>
                </table>


                <button type="button" class="btn btn-success mt-2" @click="saveTerminals()"><i class="fa fa-save"></i> Gem</button>

            </b-card-body>
        </b-card>


    </div>
</template>

<script>
    export default {
        data: () => ({
            selected: [],
            terminals: [],
        }),
        components: {},
        computed: {

        },
        watch: {

        },
        methods: {
            getTerminals() {
                this.$http.get("/api/flatpay/terminals?showHidden=true").then(x => {
                    this.terminals = x.data
                })
            },
            setDefault(terminal) {
                this.terminals.forEach(x => x.default = false)
                terminal.default = true
            },

            saveTerminals() {
                this.$http.post("/api/flatpay/terminals", this.terminals).then(x => {
                    this.getTerminals()
                })
            }
        },
        created() {
            this.getTerminals()
        },
        mounted() { }
    };
</script>

<style lang="scss">
</style>